import React from 'react';
import { Icon } from '@mui/material';
import styles from './styles';

export const OpenCircle = (props) => {
  return <Icon {...props}>radio_button_unchecked</Icon>;
};

export const FinishedCircle = (props) => {
  return <Icon {...props}>check_circle</Icon>;
};

export const HalfCircle = (props) => {
  const classes = styles();
  return (
    <div className={classes.HalfCircle} {...props}>
      <div className="halfFill" />
      <OpenCircle />
    </div>
  );
};
